/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneCategoriesRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: any;

  reactEnabled() {
    return true;
  }

  buildRouteInfoMetadata() {
    let metadata = { react: this.reactEnabled() };
    return metadata;
  }

  get titleToken() {
    return this.intl.t('standalone.navbar.categories');
  }
}

export default ReactRoute(StandaloneCategoriesRoute, { overrideRenderTemplate: false });
